import Button from '@/gf/components/ButtonOld'
import Modal from '@/gf/components/Modal'
import Select from '@/gf/components/Select'
import Spinner from '@/gf/components/Spinner'
import TextArea from '@/gf/components/TextArea'
import useMsgs from '@/gf/hooks/useMsgs'
import useToggle from '@/gf/hooks/useToggle'
import StoreOrderM from '@/gf/modules/StoreOrder'
import UserContext from '@/gf/modules/User'
import * as api from '@/suppliers/modules/api'
import React from 'react'
import useSession from '../hooks/useSession'
import { StoreOrder } from '../pages/Order/useFetchStoreOrder'

const CancelOrderModal: React.FC<{
  storeOrder: Omit<StoreOrder, 'payOnInvoice'>
  isOpen: boolean
  close: () => void
  onOk: () => void
}> = ({ storeOrder, isOpen, close, onOk }) => {
  const [_, msgsMgr] = useMsgs()
  const { user } = useSession()
  const [spinnerLive, spinner] = useToggle()
  const [emailText, setEmailText] = React.useState('')
  const [sendEmail, _setSendEmail] = React.useState<boolean>(false)
  const [reasonId, setReasonId] = React.useState('')
  const [reasonDetails, setReasonDetails] = React.useState('')

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    spinner.on()

    const reason = (() => {
      if (!reasonId) return null
      if (reasonId === '5') return { id: reasonId, details: reasonDetails }
      return { id: reasonId }
    })()

    api
      .cancelStoreOrder({
        storeOrderId: storeOrder.id,
        notes: emailText,
        sendEmail: UserContext.isAdmin(user) ? sendEmail : true,
        reason,
      })
      .then((result) => {
        if (result === 'ok') {
          onOk()
          msgsMgr.add('Order cancelled.', 'positive')
          setEmailText('')
        } else {
          msgsMgr.addUnknownError()
        }

        spinner.off()
        close()
      })
  }

  const reasonsEnabled = storeOrder.features.storeOrderTimelineV1
  const reasonOptions = StoreOrderM.CANCEL_REASONS.map((r) => ({
    id: r.id,
    display: r.title,
  }))

  return (
    <Modal
      open={isOpen}
      onClose={close}
      title="Cancel Order"
      footerAction={
        <Button
          title="Cancel Order"
          disabled={spinnerLive || (reasonsEnabled && !reasonId)}
          form="cancel-order"
          type="submit"
        />
      }
    >
      {spinnerLive ? (
        <Spinner />
      ) : (
        <form id="cancel-order" onSubmit={onSubmit}>
          <p className="mb-4">This will cancel the order and the customer will not be charged.</p>

          {reasonsEnabled && (
            <div className="mb-4">
              <Select
                options={reasonOptions}
                currentId={reasonId}
                placeholder="Please select reason for canceling..."
                onChange={setReasonId}
                required
              />
            </div>
          )}

          {reasonId === '5' && (
            <TextArea
              required
              placeholder="Reason for cancelation..."
              value={reasonDetails}
              onChange={(e) => setReasonDetails(e.target.value)}
              onBlur={(_e) => setReasonDetails(reasonDetails.trim())}
              className="mb-4"
            />
          )}
        </form>
      )}
    </Modal>
  )
}

export default CancelOrderModal
